import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './beforeEach'
// Routes
import Dashboard from '../views/dashboard/index'
import Login from '../views/login/index'
import Register from '../views/register/index'
import Questionnaire from '../views/questionnaire/index'
import User from '../views/user/index'
import Company from '../views/company/index'
import Competence from '../views/competence/index'
import Answered from '../views/answered/index'
// Containers
const Clean = () => import(/* webpackChunkName: "cleanLayout" */ '../containers/Clean.vue')
const Full = () => import(/* webpackChunkName: "fullLayout" */ '../containers/Full.vue')

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Inicio',
      component: Full,
      children: [
        Dashboard.route,
        Dashboard.report,
        Register.create,
        Questionnaire.retrieve,
        Questionnaire.config,
        Answered.report,
        Answered.general,
        User.modify,
        User.profile,
        User.password,
        Company.create,
        Company.modify,
        Company.edit,
        Competence.modify,
        Competence.create
      ]
    },
    {
      path: '/',
      name: 'Clean',
      component: Clean,
      children: [
        Login.route,
        Login.company,
        Login.captation
      ]
    }
  ]
})

// const getRoutesList = (routes, pre) => {
//   return routes.reduce((array, route) => {
//     const path = `${pre}${route.path}`
//
//     if (route.path !== '*') {
//       array.push(path)
//     }
//
//     if (route.children) {
//       array.push(...getRoutesList(route.children, `${path}`))
//     }
//
//     return array
//   }, [])
// }
// const getRoutesXML = () => {
//   const list = getRoutesList(router.options.routes, 'https://meugestor.app')
//     .map(route => `<url><loc>${route}</loc></url>`)
//     .join('\r\n')
//   return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
//     ${list}
//   </urlset>`
// }
// const writeSiteMap = async () => {
//   const content = getRoutesList(router.options.routes, 'https://progeta.app')
//   console.log(JSON.stringify(content))
// }
// writeSiteMap()
router.beforeEach(beforeEach)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js